<template>
    <div style="touch-action: none">
        <slot />
        <div
            ref="clone"
            class="_clone">
            <slot name="clone" />
        </div>
    </div>
</template>
<script>
    import interact from "interactjs";
    export default {
        props: {
            resizeEdges: {
                type: Object,
                required: false,
                default: function () {
                    return { top: true, left: true, bottom: true, right: true };
                }
            },
            isDraggable: { type: Boolean, required: false, default: false },
            isResizable: { type: Boolean, required: false, default: false },
            isDropzone: { type: Boolean, required: false, default: false },
            dropzoneAccept: { type: String, required: false, default: null },
            dropzoneOverlap: { type: [Number, String], required: false, default: "pointer" },
            dropzoneChecker: { type: Function, required: false, default: null },
            manualStart: { type: Boolean, required: false, default: false },
            autoScroll: { type: [Boolean, Object], required: false, default: true },
            draggableOptions: {
                type: Object,
                required: false,
                default() {
                    return {};
                }
            }
        },
        emits: [
            "initialMove",
            "dragStart",
            "dragMove",
            "dragEnd",
            "resizeStart",
            "resizeMove",
            "resizeEnd",
            "dropzoneDragEnter",
            "dropzoneDragLeave",
            "dropzoneActivate",
            "dropzoneDeactivate",
            "dropzoneDrop",
            "dropzoneMove"
        ],
        watch: {
            autoScroll() {
                interact(this.$el).unset();
                this.hookUpInteract();
            }
        },
        beforeUnmount() {
            interact(this.$el).unset();
        },
        mounted() {
            this.hookUpInteract();
        },
        methods: {
            hookUpInteract() {
                const controller = this;
                interact(this.$el).styleCursor(false);
                if (this.isDraggable) {
                    interact(this.$el)
                        .draggable({
                            ignoreFrom: "[no-interact]",
                            autoScroll: this.autoScroll,
                            manualStart: this.manualStart,
                            onstart: this.getHandler("dragStart"),
                            onmove: this.getHandler("dragMove", true),
                            onend: this.getHandler("dragEnd"),
                            ...this.draggableOptions
                        })
                        .on("move", function (event) {
                            const interaction = event.interaction;
                            if (interaction.pointerIsDown && !interaction.interacting()) {
                                controller.initialMove(event);
                            }

                            // Prevent Highlighting elements while dragging
                            if (event.interaction.interacting()) {
                                event.preventDefault();
                            }
                        });
                }
                if (this.isResizable) {
                    interact(this.$el).resizable({
                        edges: this.resizeEdges,
                        onstart: this.getHandler("resizeStart"),
                        onmove: this.getHandler("resizeMove", true),
                        onend: this.getHandler("resizeEnd")
                    });
                }
                if (this.isDropzone) {
                    interact(this.$el).dropzone({
                        accept: this.dropzoneAccept,
                        overlap: this.dropzoneOverlap,
                        checker: this.dropzoneChecker,
                        ondragenter: this.getHandler("dropzoneDragEnter"),
                        ondragleave: this.getHandler("dropzoneDragLeave"),
                        ondropactivate: this.getHandler("dropzoneActivate"),
                        ondropdeactivate: this.getHandler("dropzoneDeactivate"),
                        ondrop: this.getHandler("dropzoneDrop"),
                        ondropmove: this.getHandler("dropzoneMove")
                    });
                }
            },
            getHandler(eventName, unfocus) {
                return (event) => {
                    this.$emit(eventName, event);
                    if (unfocus) {
                        this.unFocus();
                    }
                };
            },
            initialMove(event) {
                if (this.isDraggable || this.isResizable) {
                    // Emit initial move which used in conjucture with manualStart
                    // to provide a means to manually hook an element to the interact event.
                    this.$emit("initialMove", event);
                }
            },
            // Empty any selection
            unFocus() {
                if (document.selection) {
                    document.selection.empty();
                } else {
                    const selection = window.getSelection();
                    if (selection.rangeCount > 0 && selection.getRangeAt(0).getClientRects().length > 0) {
                        selection.removeAllRanges();
                    }
                }
            }
        }
    };
</script>
<style lang="scss" scoped>
    ._clone {
        display: inline-block;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0.5;
    }
</style>
